import React from "react";
import { cn } from "utils";

import "./styles.css";
import { FileDropZone } from "./FileDropZone";
import { FilePreview } from "./FilePreview";
import { UploadActions } from "./UploadActions";
import { useResumeUploader } from "./hooks/useResumeUploader";
import { ALLOWED_EXTENSIONS } from "./hooks/useFileValidation";

const Uploading = () => {
  return (
    <div className="flex flex-col items-center justify-center px-6 pb-12">
      <span className="resume-uploader-loader" />
      <div className="mt-6 text-center text-lg font-medium text-[#334155]">
        Uploading...
      </div>
    </div>
  );
};

const FileInput = ({ onFileInput }) => {
  return (
    <div className="mb-9 mt-3">
      <input
        type="file"
        id="resume-uploader-file-input"
        accept={ALLOWED_EXTENSIONS.map((extension) => `.${extension}`).join(
          ","
        )}
        onChange={onFileInput}
        className="hidden"
      />
    </div>
  );
};

export const ResumeUploader = ({ onPrepareUpload, onUploadSuccess }) => {
  const {
    selectedFile,
    isDragOver,
    isUploading,
    isFileInvalid,
    isFileTooLarge,
    uploadError,
    removeSelectedFile,
    handleUploadClick,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileInput,
  } = useResumeUploader({
    onPrepareUpload,
    onUploadSuccess,
  });

  const isBusy = isUploading;

  const openFileBrowser = () => {
    if ((selectedFile && !isFileInvalid && !isFileTooLarge) || isBusy) {
      return;
    }

    document.getElementById("resume-uploader-file-input")?.click();
  };

  return (
    <div>
      {isBusy ? (
        <div className="mt-10 w-full text-center">
          <Uploading />
        </div>
      ) : (
        <>
          <div
            className={cn(
              "flex w-full cursor-pointer justify-center transition-colors duration-200 bg-[#F7F9FB] rounded-xl py-6 px-8 ",
              isDragOver && "bg-blue-50"
            )}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={openFileBrowser}
          >
            {!selectedFile ? (
              <FileDropZone />
            ) : (
              <FilePreview
                selectedFile={selectedFile}
                isFileInvalid={isFileInvalid}
                isFileTooLarge={isFileTooLarge}
                onRemoveFile={removeSelectedFile}
              />
            )}
          </div>
          <FileInput onFileInput={handleFileInput} />
        </>
      )}

      {!isBusy && (
        <UploadActions
          selectedFile={selectedFile}
          isFileInvalid={isFileInvalid}
          isFileTooLarge={isFileTooLarge}
          uploadError={uploadError}
          onUpload={handleUploadClick}
          onCancel={removeSelectedFile}
        />
      )}
    </div>
  );
};
